<div class="manage-units">
  <div
    class="global"
  >
    <h3>
      Property Settings
    </h3>

    @if (app) {
      <motn-app-global-settings
        [app]="app"
        [patchChildApps]="true"
      ></motn-app-global-settings>
    }
  </div>

  <div
    class="units"
  >
    <h3>
      Unit Settings

      <button
        class="small green"
        (click)="openAddUnitMenu()"
      >
        <i class="far fa-plus"></i> Add Unit
      </button>
      @if (addUserMenuOptions) {
        <motn-popover-menu
          [optionGroup]="addUserMenuOptions"
          (clickedOutsideMenu$)="closeAddUserMenu()"
          (clickedOption$)="closeAddUserMenu()"
        ></motn-popover-menu>
      }
    </h3>

    <motn-sort-table
      [table$]="table$"
    ></motn-sort-table>
  </div>
</div>
